var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-channel-image"},[(!_vm.unitData.list)?_c('p'):_vm._e(),_vm._l((_vm.unitData.list),function(item,i){return _c('a',{key:i},[_c('c-image',{staticClass:"item",attrs:{"src":item.img_url,"mode":"aspectFill"}})],1)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }